<template>
  <DialogLayout
    title="新規追加"
    :visible.sync="dialogVisible"
    :destroy-on-close="true"
    width="65em"
    @open="open"
  >
    <template #form>
      <RegistrationSymbolMasterForm
        ref="registrationSymbolForm"
        v-model="registrationSymbolFormModel"
        label-width="10em"
        formMode="register"
        :autocomplete-registration-symbol-set="autocompleteRegistrationSymbolSet"
        :autocomplete-owner-code-set="autocompleteOwnerCodeSet"
        :autocomplete-model-code-set="autocompleteModelCodeSet"
      />
    </template>
    <template #footer>
      <RegisterDialogFooter
        @clear="clickClear"
        @register="clickRegister"
      />
    </template>
 </DialogLayout>
</template>

<script>
import DialogLayout from '@/components/templates/DialogLayout.vue'
import RegistrationSymbolMasterForm from '@/components/organisms/dialog/master/RegistrationSymbolMasterForm.vue'
import RegisterDialogFooter from '@/components/organisms/dialog/RegisterDialogFooter.vue'
import RegistrationSymbolAutocompleteLoader from '@/mixins/RegistrationSymbolAutocompleteLoader.vue'

export default {
  components: {
    DialogLayout,
    RegistrationSymbolMasterForm,
    RegisterDialogFooter
  },
  mixins: [
    RegistrationSymbolAutocompleteLoader
  ],
  props: {
    autocompleteRegistrationSymbolSet: {
      type: Array,
      default: () => ([])
    },
    autocompleteOwnerCodeSet: {
      type: Array,
      default: () => ([])
    },
    autocompleteModelCodeSet: {
      type: Array,
      default: () => ([])
    },
    currentRow: {
      type: Object,
      default: () => ({})
    },
    visible: Boolean
  },
  data () {
    return {
      registrationSymbolFormModel: {
        registration_symbol: undefined,
        owner_code: undefined,
        start_date: undefined,
        end_date: undefined,
        date_range: undefined,
        model_code: undefined,
        aircraft_type: undefined,
        weight_1: undefined,
        noise_level_1: undefined,
        weight_2: undefined,
        noise_level_2: undefined,
        weight_3: undefined,
        noise_level_3: undefined,
        remarks: undefined,
        aircraft_attribute: undefined
      }
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.visible
      },
      set (visible) {
        this.$emit('update:visible', visible)
      }
    }
  },
  mounted () {
  },
  methods: {
    clickClear () {
      this.$refs.registrationSymbolForm.clearFields()
    },
    async clickRegister () {
      this.$loadingMask.on()

      this.$refs.registrationSymbolForm.validate()
        .then((valid) => {
          return this.$axios.post('/registration-symbol', this.registrationSymbolFormModel)
        })
        .then((res) => {
          this.$fcMessage.showMessage(res.data.message)
          this.dialogVisible = false
          this.margeRegistrationSymbolSet(this.registrationSymbolFormModel.registration_symbol)
          this.margeOwnerCodeSet(this.registrationSymbolFormModel.owner_code)
          this.margeModelCodeSet(this.registrationSymbolFormModel.model_code)
          this.$emit('refresh')
        })
        .catch((e) => {
          if (e.response) {
            switch (e.response.status) {
              case 402:
                this.$fcMessage.showMessage(e.response.data.message)
                break
              default:
            }
          }
        })
        .finally(() => {
          this.$loadingMask.off()
        })
    },
    open () {
      const trimItem = ['registration_symbol', 'owner_code', 'model_code']
      this.$nextTick(() => {
        this.$refs.registrationSymbolForm.clearFields()
        Object.keys(this.registrationSymbolFormModel)
          .forEach((x) => {
            if (trimItem.includes(x) && this.currentRow[x]) {
              this.currentRow[x] = this.currentRow[x].trimEnd()
            }
            this.$set(this.registrationSymbolFormModel, x, this.currentRow[x])
          })
      })
    }
  }
}
</script>

<style lang="scss">
</style>
